import JSConfetti from 'js-confetti'
import { Injectable } from '@angular/core'
import { BehaviorSubject, defer, fromEvent } from 'rxjs'
import { filter, finalize, map, scan, take } from 'rxjs/operators'

const PASSWORD = 'iamroot'

@Injectable({ providedIn: 'root' })
export class SecretService {
  secretsEnabled$ = defer(() => {
    this.subscriberCount++
    return this.secretsEnabled.pipe(finalize(() => {
      this.subscriberCount--
    }))
  })
  private secretsEnabled = new BehaviorSubject(false)
  private subscriberCount = 0

  constructor () {
    if (new URLSearchParams(window.location.search).get(PASSWORD) !== null) {
      this.secretsEnabled.next(true)
      return
    }
    fromEvent<KeyboardEvent>(document, 'keydown', { passive: true }).pipe(
      map(event => event.key),
      scan((buf, key) => {
        return [...buf, key].slice(-PASSWORD.length)
      }, []),
      map(buf => buf.join('')),
      filter(password => password === PASSWORD),
      filter(() => this.subscriberCount > 0),
      take(1),
    ).subscribe(() => {
      this.secretsEnabled.next(true)
      const jsConfetti = new JSConfetti()
      jsConfetti.addConfetti()
    })
  }
}
